import { observer } from 'mobx-react';

import NavButton from '../shared/components/Button/NavButton';
import HeaderLevel1 from '../shared/components/Typography/HeaderLevel1';
import { HubSpotFormConfirmation } from '../shared/hubSpot/Confirmation/HubSpotFormConfirmation';
import { HubSpotFormPage } from '../shared/hubSpot/HubSpotFormPage';
import ProductSummary from '../shared/hubSpot/ProductSummary/ProductSummary';
import Logger from '../shared/Logger';
import css from './EmailMyConfigurationPage.css';
import { EmailMyConfigurationState } from './EmailMyConfigurationState';

@observer
export default class EmailMyConfigurationPage extends HubSpotFormPage<EmailMyConfigurationState> {
  get initialFormData() {
    return {
      request_configuration_receipt: this.props.state.getCode(),
    };
  }

  render() {
    const { appState, state } = this.props;
    const { translation } = appState;
    if (state.isFormSubmitted) {
      return (
        <HubSpotFormConfirmation
          buttonLink={
            appState.storeResponse.storeContext.showroomConfig.homePageUrl || appState.navigationState.homeUrl
          }
          translation={translation.emailMyConfigurationPage.confirmation}
        />
      );
    }
    return (
      <div className={css.page}>
        <NavButton className={css.navigation} onClick={state.backToSummary} back>
          {translation.emailMyConfigurationPage.goBackLink}
        </NavButton>
        <HeaderLevel1 className={css.title} centered>
          {translation.emailMyConfigurationPage.title}
        </HeaderLevel1>
        <div className={css.container} id="hsEmailMyConfigurationForm">
          <div className={css.formContainer}>
            {this.props.appState.store.canEmailMyConfiguration() ? super.render() : null}
          </div>
          <ProductSummary
            shoppingCartClassName={css.shoppingCartContainer}
            productPreviewClassName={css.productDetailsPreviewContainer}
            state={state}
            translation={translation.cart.summary}
          />
        </div>
      </div>
    );
  }
}
